import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { formatDateTimeKst } from '../../utils/dateUtils';

type Props = {
  /** 수정 시 최초 작성 시각 */
  createdAt?: string | null;
};

/** 관제 메시지 작성/수정 다이얼로그용 시각 표시 (Asia/Seoul) */
const OperatorMessageComposeTime: React.FC<Props> = ({ createdAt }) => {
  const [now, setNow] = useState(() => formatDateTimeKst(new Date()));

  useEffect(() => {
    const tick = () => setNow(formatDateTimeKst(new Date()));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <>
      {createdAt ? (
        <Typography variant="body2" color="text.secondary">
          최초 작성: {formatDateTimeKst(createdAt)}
        </Typography>
      ) : null}
      <Typography variant="body2" color="text.secondary">
        {createdAt ? '현재 시각' : '작성 시각'}: {now}
      </Typography>
    </>
  );
};

export default OperatorMessageComposeTime;
